import hasFloatValidDigits from '~/utils/Number/hasFloatValidDigits';

export default function isValidPackageSize(packageSize: number): boolean {
	return packageSize > 0 && hasFloatValidDigits(packageSize, 17, 10);
}
